module.exports = "/assets/6754b0776ca57dc0f375e4b6697a312c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B9.png
// module id = 1222
// module chunks = 0